var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"LanguageSelector"}},[_c('button',{class:{active: _vm.lang === 'en'},on:{"click":function($event){_vm.selectLanguage('en')}}},[_vm._v("English")]),_vm._v(" "),_c('button',{class:{active: _vm.lang === 'fr'},on:{"click":function($event){_vm.selectLanguage('fr')}}},[_vm._v("Français")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e79285c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguageSelector.vue
// module id = null
// module chunks = 